export const getClassNames = (...classes: string[]): string =>
  classes.filter(Boolean).join(' ');

export const formatDateToISOString = (date: string) => {
  return new Date(date).toISOString().split('.')[0] + 'Z';
};
